import React, { ReactElement } from 'react'
import ComponentMap, { ContentfulComponentId } from '../ComponentMap'

export type CodeModuleComponentProps = Queries.CODEMODULEFragment
const CodeModule = ({ contentfulid }: CodeModuleComponentProps): ReactElement => {
  return contentfulid ? <ComponentMap internal={{ type: contentfulid as ContentfulComponentId }} /> : <></>
}

export default CodeModule
